import React from 'react';
import Gravatar from 'react-gravatar';
import moment from 'moment';

import PartialStatus from './Status/Partial';

import IconButton from 'material-ui/IconButton';
import { withRouter } from 'react-router-dom';

const UserTrackItem = ({ document, last_sync_at, onRequestClose }) => {

    if (!document) {
        return null;
    }

    const vehicle = document.vehicle || {};
    const user = vehicle.user || {};

    const location = document.location;

    const updated_at = moment(location.datetime);
    const now = moment();

    const diff = now.diff(updated_at, 'days');
    let offiline_msg = null;

    if (diff >= 1) {
        offiline_msg = (<div className="warning"><i>Há mais de {diff} dia(s) sem receber atualização de GPS.</i></div>);
    }

    return (
        <div className="user-track-item">
            <div className="user-track-item-header">
                <Gravatar email={user.email || 'unknow@polibrasnet.com.br'} size={48} default="mm" className="avatar" />

                <div className="user-track-item-header-info">
                    <h4>{user.display_name}</h4>
                    <small>{document.vehicle_id}</small>
                </div>

                <IconButton onClick={onRequestClose}>
                    <i className="material-icons">close</i>
                </IconButton>
            </div>

            <p className="info">
                <b>Últ. Atualização</b>: {moment(location.datetime).format('DD/MM/YYYY HH:mm:ss')}<br />
                <b>Entregas</b>: <PartialStatus id={document.id} /><br />
            </p>

            {offiline_msg}
        </div>
    );

}

export default withRouter(UserTrackItem);



// WEBPACK FOOTER //
// ./src/components/UserTrackItem.js